import { Navigate, useLocation } from 'react-router-dom';

/**
 * Sends an old URL to where its page lives now, keeping the query: emails
 * and notifications already sent link to `/documents?view=requests` and the
 * like, and must still open the Requests view.
 */
export const LegacyRedirect = ({ to }: { to: string }) => {
  const { search, hash } = useLocation();
  return <Navigate to={`${to}${search}${hash}`} replace />;
};
